import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import { fromJS } from 'immutable'

import app from 'containers/app'
import * as SocketConstants from 'app/modules/socket/constants'
import * as UserActions from 'app/modules/user/actions'

function pushGates(action$, store) {
  return action$
    .ofType(SocketConstants.JOIN_CHANNEL_PENDING)
    .pluck('payload')
    .filter((payload) => payload.clusterName === SocketConstants.SocketCluster.MESSAGES)
    .filter((payload) => payload.channelName === SocketConstants.SocketChannel.ORG_PRIVATE)
    .switchMap(({ channel, leaveChannel$ }) => {
      return Observable.create((observer) => {
        channel.on('gates-updated', (payload) => {
          app.actions.GateActions.gatesUpdated(payload)
          observer.next(UserActions.receiveGates(fromJS(payload)))
        })
      })
        .takeUntil(leaveChannel$)
    })
}

export const epic = combineEpics(
  pushGates
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/gates/epic.js